/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import commonUtil from '../../../../../utils/commonUtil';
import serverClientUtil from '../../../../../utils/serverClientUtil';
import ApplyCSS from '../../../../../components/ApplyCSS';
import Tagging from '../../../../../components/Tagging';
import { handleUserLogout, _handleUserLogin } from '../../../../../pages/Accounts/createAccount/actions';
import * as BrowseAndNevigateSearchAction from '../../../../../pages/BrowseAndNavigate/BrowseAndNevigateSearch/actions';
import LoginModal from '../../../../../pages/Accounts/createAccount/components/loginModal';
import TypeHeadLeft from '../../../../../components/GREcomHeader/headers/CommonTypeHeadLeft/index';

const headerData = '';
const applicationRoutes = commonUtil.getApplicationRoutes();
//const { IS_MISCOMPRAS } = process.env;
@connect(store => ({
  megaMenuData: store.megaMenuData.data,
  cartCountData: store.cartCountData.data,
  SearchedPoductData: store.SearchedPoductData.data,
}),
  { ...BrowseAndNevigateSearchAction })

class HeaderPB extends Component {
  constructor() {
    super();
    this.state = {
      headerContent: headerData,
      onHoverClass: 'no-hover',
      inputSearch: '',
    };

    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.generateSubChildCategories = this.generateSubChildCategories.bind(this);
    this.generateChildCategories = this.generateChildCategories.bind(this);
    this.generateSubCategories = this.generateSubCategories.bind(this);
    this.checkSession = this.checkSession.bind(this);
    this.searchProduct = this.searchProduct.bind(this);
    this.cartCount = 0;
    this.clickHandlerLogo = this.clickHandlerLogo.bind(this);
  }
  clickHandlerLogo() { // eslint-disable-line class-methods-use-this
    const _url = serverClientUtil.getLPFullURL();
    window.location = _url;
  }
  handleMouseEnter() {
    this.setState({ onHoverClass: 'hover-ready' });
  }
  handleMouseLeave() {
    this.setState({ onHoverClass: 'no-hover' });
  }
  cartOpenClose = () => {
    document.querySelector('.dropdown-menu.bag_01').classList.toggle('cartopen');
  }

  // TODO: this all next 4 functuons are used to show megamenu and integrated with actual service but still need to fix some work.
  generateSubChildCategories = (childCategory, subCategory) => (
    <ul>
      {childCategory ?
        this.generateRootCategories(childCategory.l3subcategories)
        :
        null
      }
      {childCategory.l3subcategories.length > 8 ? <li><a href={serverClientUtil.getLPURL() + childCategory.url} > Ver Mas+</a></li> : null}
    </ul>
  )

  generateChildCategories = (subCategory, categoryName) => {
    if (subCategory) {
      return (
        <div className="m-body_department">
          <a href="" className="a-department_title">{categoryName}</a>
          <div className="m-deparments_content-categorys flx">
            <div className="m-nav_content-category">
              {subCategory && subCategory.l2subcategories && subCategory.l2subcategories.length > 0 ?
                subCategory.l2subcategories.map((childCategory, index) => {
                  if (index < 3) {
                    return (<div className="m-nav-categorys" key={index}>
                      <h3 className="a-category_title" id={childCategory.id}>{childCategory.name}</h3>
                      {this.generateSubChildCategories(childCategory, subCategory)}
                    </div>);
                  }
                  return null;
                })
                :
                null}
            </div>
            <div className="m-nav_content-banner">
              <div>
                <a className="a-desktop__subcategoryImg" href={serverClientUtil.getLPURL() + subCategory.url}>
                  <figure>
                    <img className="a-desktop__subcategoryImg" src={subCategory.imageUrl} />
                  </figure>
                </a>
              </div>
            </div>
            <a href={serverClientUtil.getLPURL() + subCategory.url} className="allSections">Ver todas las secciones</a>
          </div>
        </div>);
    }
    return null;
  }

  generateSubCategories = L1subcategories => (
    <div className="m-popover">
      {L1subcategories && L1subcategories.length > 0 ? L1subcategories.map((subCategory, index) => (
        <div className="m-nav-department" onClick={this.handleMouseLeave} key={index}>
          <a href={serverClientUtil.getLPURL() + subCategory.url} className="a-nav-department">
            {subCategory.name}
            <span className="icon-flecha_lightsvg_derecha" />
          </a>
          {this.generateChildCategories(subCategory, subCategory.name)}
        </div>
      )) : null}
    </div>
  )
  generateRootCategories = rootCategories => (
    rootCategories && rootCategories.length > 0 ?
      rootCategories.map((rootCategory, index) => {
        if (index < 8) {
          return (
            <li>
              <a className="a-nav-catLink" id={rootCategory.id} href={serverClientUtil.getLPURL() + rootCategory.url}>
                {rootCategory.name}
              </a>
            </li>);
        }
        return null;
      })
    : null
  )
  handleUserLogout(email) {
    const url = serverClientUtil.getLPFullURL();
    this.props.handleLogoutWithAuth0(email, this.props.handleUserLogout, url);
  }
  componentDidMount() {
    this.checkSession();
    document.addEventListener('click', (e) => { this.closeSearchTab(e); });
  }
  closeSearchTab = (e) => {
    if (e.target && document.querySelector('#typeahead') && !document.querySelector('#typeahead').contains(e.target) && document.querySelector('#typeahead').style.display === 'block') {
      document.querySelector('#typeahead').style.display = 'none';
    }
  }
  handOnKeyUp = (e) => {
    e.preventDefault();
    if (e.keyCode === 13) {
      window.open(serverClientUtil.getLPFullURL() + '?s=' + e.target.value, '_self');
    }
  }
  getTaggingData = (data) => {
    const _dataLayer = {};
    _dataLayer.event = 'TSearch';
    _dataLayer.Section = data;
    return _dataLayer;
  }
  getTaggingDataFailure = (data) => {
    const _dataLayer = {};
    _dataLayer.event = 'ESearch';
    _dataLayer.STerm = data;
    return _dataLayer;
  }
  checkSession = () => {
    if (this.props.user.loaded) {
      this._ajaxLoad.style.display = 'none';
      if (this._loginLi && this.props.user && this.props.user.data && this.props.user.data.result && this.props.user.data.result.firstName) {
        this._loginLi.style.display = 'inline-block';
        this._logoutLi.style.display = 'none';
      } else if (this._loginLi && this.props.user.data.actionType === 'logout' && this.props.user.data.result.status.status === 'success' && document !== undefined) {
        this._loginLi.style.display = 'none';
        this._logoutLi.style.display = 'inline-block';
        if (window) {
          window.location.href = '/';
        }
      } else if (this._loginLi && this.props.user.data.actionType === 'activeSession') {
        this._loginLi.style.display = 'none';
        this._logoutLi.style.display = 'inline-block';
      } else if (this._loginLi && this.props.user.data.actionType === 'login' && this.props.user.data.result.status.status === 'failure') {
        this._loginLi.style.display = 'none';
        this._logoutLi.style.display = 'inline-block';
      } else {
        this._logoutLi.style.display = 'none';
        this._loginLi.style.display = 'none';
        this._ajaxLoad.style.display = 'inline-block';
      }
    }
  }
  searchProduct = () => {
    const enteredData = document.querySelector('#search').value;
    const { SearchedDetailOfPoduct } = this.props;
    this.setState({ inputSearch: enteredData });
    SearchedDetailOfPoduct(enteredData, {}).then((res) => {
      if (res.status.status === 'success') {
        const _dataLayer = this.getTaggingData(enteredData);
        this.tagging.applyGTM('SearchProduct', _dataLayer);
      } else {
        const _dataLayer = this.getTaggingDataFailure(enteredData);
        this.tagging.applyGTM('SearchProduct', _dataLayer);
      }
    });
  }
  render() {
    const { SearchedPoductData } = this.props;
    const email = (this.props.user && this.props.user.data && this.props.user.data.result) ? this.props.user.data.result.emailId : '';
    if (this._loginLi) {
      this.checkSession();
    }
    if (SearchedPoductData && SearchedPoductData.suggestion) {
      document.querySelector('#typeahead').style.display = 'block';
      document.querySelector('#typeahead').style.background = '#fff'; // TOD: Temp css applied. will emove it later.
      document.querySelector('#typeahead').style.zIndex = 999;
    }
    this.cartCount = 0;
    if (this.props.cartCountData && this.props.cartCountData.cartDetails && this.props.cartCountData.cartDetails.length > 0) {
      this.props.cartCountData.cartDetails.map(data => this.cartCount += parseInt(data.quantity, 10));
    }
    return (
      <header className="nav-bar">
        <ApplyCSS pageName="headerPB" />
        <Tagging ref={tagging => this.tagging = tagging} />
        <div className="m-nav_boutiques flx">
          <div className="o-container">
            <a className="a-nav-boutique --hover" href={serverClientUtil.getMultiEComSiteURL('LP') + '/tienda/home'} rel="noopener noreferrer" target="_blank">Liverpool</a>
            <a className="a-nav-boutique --hover" href="https://www.suburbia.com.mx/tienda/inicio/">Suburbia</a>
            <a className="a-nav-boutique --hover" href={serverClientUtil.getMultiEComSiteURL('PBK') + '/tienda/home'} rel="noopener noreferrer" target="_blank">PBKids</a>
            <a className="a-nav-boutique --hover" href={serverClientUtil.getMultiEComSiteURL('GAP') + '/tienda/home'} rel="noopener noreferrer" target="_blank">GAP</a>
            <a className="a-nav-boutique --hover" href={serverClientUtil.getMultiEComSiteURL('WS') + '/tienda/home'} rel="noopener noreferrer" target="_blank">Williams Sonoma</a>
            <a className="a-nav-boutique --hover" href={serverClientUtil.getMultiEComSiteURL('WLM') + '/tienda/home'} rel="noopener noreferrer" target="_blank">West Elm</a>

            {serverClientUtil.enableToys && <a className="a-nav-boutique --hover" href={serverClientUtil.getMultiEComSiteURL('TRU') + '/tienda/home'} rel="noopener noreferrer" target="_blank">Toys R Us</a>}
          </div>
        </div>
        <div className="nav-search_bar flx">
          <div className="o-container">
            <figure className="m-nav-search_logo p-x1">
              <a href={serverClientUtil.getLPFullURL() + '/home'}>
                <img className="a-nav-search_logo" src={commonUtil.getAssetURL() + '/images/logo-pb.png'} alt="Liverpool - Es parte de mi vida" title="Liverpool - es parte de mi vida" />
              </a>
            </figure>
            <div className="m-nav-search_input p-x1">
              <form className="nav-form">
                <div className="nav-form_control">
                  <input id="search" autoComplete="off" type="text" placeholder="Buscar..." onChange={this.searchProduct} onKeyUp={(e) => { this.handOnKeyUp(e); }} /><span className="icon-zoom" />
                </div>
                <div id="typeahead" style={{ display: 'none' }}>
                  {SearchedPoductData && SearchedPoductData.suggestion ?
                    <div className="m-typeAhead">
                      {/* <div className="m-typeAhead__left">
                        <a href={serverClientUtil.getLPFullURL() + 'tienda?s=' + this.state.inputSearch} className="a-typeAhead__aFirst">{this.state.inputSearch} en <span>Todos los Departamentos</span></a>
                        {SearchedPoductData && SearchedPoductData.suggestion && SearchedPoductData.suggestion.categories ?
                          SearchedPoductData.suggestion.categories.map(data => (
                            <a className="a-typeAhead__a" href={serverClientUtil.getLPFullURL() + data.url} key={data.categoryId}>&nbsp;
                              {data.categoryName}
                            </a>
                          ))
                          :
                          null}
                      </div> */}
                      <TypeHeadLeft {...this.props} inputSearch={this.state.inputSearch} color={'#990000'} />
                      <div className="m-typeAhead__right">
                        <p className="a-typeAhead__title">Lo más buscado</p>
                        <div className="m-typeAhead__results">
                        <React.Fragment>
                          {SearchedPoductData && SearchedPoductData.suggestion && SearchedPoductData.suggestion.products ?
                            SearchedPoductData.suggestion.products.map(data => (
                              <div className="m-typeAhead__resultCard">
                                <a href={serverClientUtil.getLPURL() + data.url}>
                                  <figure className="m-resultCard__figure">
                                    {data && data.imgUrl && data.imgUrl !== null && data.imgUrl !== 'null' && data.imgUrl !== undefined && data.imgUrl !== 'undefined' ?
                                      <img id={'ahead_' + data.productId} alt={data.productName} src={data.imgUrl} />
                                      :
                                      <img id={'ahead_defaultImage'} alt={'ahead_defaultImage'} src={commonUtil.getAssetURL() + '/images/filler_REC.gif'} />
                                    }
                                    <figcaption className="a-resultCard__title">
                                      <p className="a-resultCard__title">{data.productName}</p>
                                    </figcaption>
                                  </figure>
                                </a>
                              </div>
                            ))
                            :
                            null
                          }
                        </React.Fragment>
                        </div>
                      </div>
                    </div>
                    :
                    null}
                </div>
              </form>
            </div>
            <LoginModal ref={login => this.loginModal = login} _handleUserLogin={this.props._handleUserLogin} myProps={this.props} label={this.props.label} />
            <div className="m-nav-search_myorders p-x1">
              <a href={serverClientUtil.getLPFullURL() + serverClientUtil.getMisComprasURL()} className="a-nav-a">{serverClientUtil.getMisComprasText()}</a>
            </div>
            <div className="m-nav-search_session p-x1">
              {/* <button className="a-nav-a a-btn_empty" style={{ display: 'none' }} onClick={() => this.loginModal.showLoginModal()} ref={_logoutLi => this._logoutLi = _logoutLi} > */}
              <button className="a-nav-a a-btn_empty" style={{ display: 'none' }} onClick={this.props.handleLoginWithAuth0} ref={_logoutLi => this._logoutLi = _logoutLi} >
                <a>Iniciar sesión </a>
              </button>
              <div className="m-session_user" style={{ display: 'none' }} ref={_loginLi => this._loginLi = _loginLi}>
                <div className="a-nav-a a-session_user">
                  Hola {this.props.user.loaded && this.props.user.data && this.props.user.data.result ? this.props.user.data.result.firstName : null}
                  <span className="icon-flecha_gruesa_abajo" />
                </div>
                <div className="m-session_menu m-popover">
                  <ul>
                    <li><a href={serverClientUtil.getLPFullURL() + '/users/myAccount'} className="a-nav-link"><span>Mi cuenta</span></a></li>
                    <li><a href={serverClientUtil.getLPFullURL() + serverClientUtil.getMisComprasURL()} className="a-nav-link"><span>{serverClientUtil.getMisComprasText()}</span></a></li>
                    <li><a href={serverClientUtil.getLPFullURL() + '/checkout/airtimeTicket'} className="a-nav-link"><span>Mi Tiempo Aire</span></a></li>
                    <li><a href={serverClientUtil.getLPFullURL() + '/users/creditCards'} className="a-nav-link"><span>Mis Tarjetas</span></a></li>
                    <li><button className="a-nav-link a-btn_empty" onClick={() => { this.handleUserLogout(email); }}>Cerrar Sesión</button></li>
                  </ul>
                </div>
                <div className="sessionMenu dropdown login" ref={_ajaxLoad => this._ajaxLoad = _ajaxLoad} >
                  <a>
                    <img src={commonUtil.getAssetURL() + '/images/ajax-loader.gif'} style={{ verticalAlign: 'middle', maxHeight: '20' }} width="80" height="80" alt="shop" />
                  </a>
                </div>
              </div>
            </div>
            <div className="m-nav-search_mycart p-x1">
              <a href={serverClientUtil.getLPFullURL() + '/cart'}>
                {this.cartCount >= 0 ? <React.Fragment>
                  <figure><img src={commonUtil.getAssetURL() + '/images/bolsita.png'} className="a-mycart_img" /><span className="a-articles" >{this.cartCount}</span></figure> </React.Fragment> :
          null
                }
              </a>
            </div>
          </div>
        </div>
        <nav className="m-nav-main">
          {/* <div className="backopacity" /> */}
          <div className="o-container">
            <div className="m-nav-main_left flx">
              <div className="m-nav_departments">
                <a className="a-nav-a_main a-departments --hover">Categor&iacute;as<span className="icon-flecha_light_abajo" /></a>
                {this.props.megaMenuData.l1Categories && this.props.megaMenuData.l1Categories.length > 0 ? this.generateSubCategories(this.props.megaMenuData.l1Categories) : null}
              </div>
              <button
                className="a-nav-a_main a-gif --hover" onClick={() => {
                  const eventDetails = this.props.eventDetails && this.props.eventDetails.data && this.props.eventDetails.data.eventList;
                  if (eventDetails && eventDetails.length === 1) {
                    browserHistory.push(commonUtil.getRouteByParameter(applicationRoutes.giftList, { eventID: eventDetails[0].eventId }));
                  } else if (eventDetails && eventDetails.length > 1) {
                    browserHistory.push(applicationRoutes.multipleEvents);
                  } else if (window) {
                    window.location.href = '/';
                  }
                }}
              ><a>Mesa de regalos</a></button>
            </div>
            <div className="m-nav-main_right flx">
              <a href="https://assetspwa.potterybarn.com.mx/ayuda/index.html" className="a-nav-a_main a-help  --hover" >Ayuda</a>
              <a href={serverClientUtil.getLPFullURL() + '/browse/storelocator'} className="a-nav-a_main a-stores --hover" >Tiendas</a>
            </div>
          </div>
        </nav>
      </header>
    );
  }
}
const mapStateToProps = state => ({
  label: state.labels.data,
  user: state.user,
  eventDetails: state.eventDetail,
});
const matchDispatchToProps = dispatch => bindActionCreators({ handleUserLogout, _handleUserLogin }, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(HeaderPB);
